module.exports = __webpack_public_path__ + "img/right-arrow.e46b6fd1.png";